export const VehicleInfoValidationSchema = {
    vehicle_make: [
        { rule: "required", message: "Vehicle make required" },
    ],
    vehicle_model: [
        { rule: "required", message: "Vehicle model required" },
    ]
}